import { render } from "./UserMenu.vue?vue&type=template&id=7670cfc2&scoped=true"
import script from "./UserMenu.vue?vue&type=script&lang=js"
export * from "./UserMenu.vue?vue&type=script&lang=js"

import "./UserMenu.vue?vue&type=style&index=0&id=7670cfc2&lang=less&scoped=true"

import exportComponent from "/home/runner/work/cloudstack/cloudstack/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7670cfc2"]])

export default __exports__